import { render } from "./SummaryRestart.vue?vue&type=template&id=2f7bac70"
import script from "./SummaryRestart.vue?vue&type=script&lang=js"
export * from "./SummaryRestart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__